import { Breadcrumb } from "@components/anti/Breadcrumb"
import { Cover } from "@components/anti/Cover"
import { linkLocations } from "src/helper/page-url"
import { translations } from "src/helper/translations"

function LocationDetailCover({ title, img, imgMd, text, locale }) {
  return (
    <section className="sc-location-detail-cover">
      <Cover
        title={title}
        text={text}
        img={img}
        imgMd={imgMd}
        imgHeight="h-vh-100"
        scrollHint
        imgOverlay={40}
        breadcrumb={
          <Breadcrumb
            path={[
              {
                title: translations[`all_outlets_${locale}`],
                url: linkLocations,
              },
              { title },
            ]}
            theme="dark"
          />
        }
      />
    </section>
  )
}

export default LocationDetailCover
